import { CarouselContainer } from "app/pages/website-analysis/traffic-sources/mmx/components/InsightsAssistant/StyledComponents";
import { Carousel } from "pro-features/components/Carousel/src/Carousel";
import { InsightSectionHeader } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewGraph/SearchTrafficInsights/InsightSectionHeader";
import { Insight } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewGraph/SearchTrafficInsights/Insight";

export const InsightsCarousel = ({
    sortedInsightWithValue,
    setTab,
    setCategoryOnClick,
    setLegends,
    selectedInsightId,
    setSelectedInsightIdAsync,
    setGranularity,
    visitedInsights,
}) => {
    return (
        <CarouselContainer>
            {
                <Carousel
                    margin={16}
                    offset={24}
                >
                    {...sortedInsightWithValue.map((insight, index, insights) => (
                        <div key={index}>
                            <InsightSectionHeader
                                insights={insights}
                                insight={insight}
                                index={index}
                            />
                            <Insight
                                insightId={index}
                                {...insight}
                                setTab={setTab}
                                setCategory={setCategoryOnClick}
                                setLegends={setLegends}
                                selectedInsightId={selectedInsightId}
                                setSelectedInsightId={setSelectedInsightIdAsync}
                                setGranularity={setGranularity}
                                isVisited={visitedInsights[index]}
                            />
                        </div>
                    ))}
                </Carousel>
            }
        </CarouselContainer>
    );
};
